import * as React from "react"
import { ThemeToggler } from "gatsby-plugin-dark-mode"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { BsSun, BsMoon } from "react-icons/bs"

const Footer = ({ siteTitle }) => {
  const isBrowser = () => typeof window !== "undefined"

  return (
    <footer className="px-4 divide-y text-zinc-200 dark:bg-black bg-zinc-700 dark:text-gray-100">
      <div className="container flex flex-col justify-between py-10 mx-auto space-y-8 lg:flex-row lg:space-y-0">
        <div className="lg:w-1/2">
          <AniLink
            rel="noopener noreferrer"
            to="/"
            paintDrip
            duration={0.5}
            hex={
              isBrowser() && window.localStorage.theme === "dark"
                ? "#fff"
                : "#000"
            }
            className="flex justify-center space-x-3 lg:justify-start"
          >
            <div className="flex items-center justify-center">
              <svg
                className=" h-9 fill-zinc-300	dark:fill-white"
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 594 252"
                version="1.1"
                viewBox="0 0 594 252"
                xmlSpace="preserve"
              >
                <path d="M240.8 103.3H236v43.3h4.5c12 0 22.2-6.6 22.2-21.6.1-13.9-8.9-21.7-21.9-21.7zM297 11.2L12 57.6v136.8l285 46.4 285-46.4V57.6L297 11.2zM97.8 163.6h-31V86.3h28.7c13.7 0 23 5.3 23 20.1 0 7-2.3 12.6-8.5 15.8v.2c11.1 1.4 15.8 8.9 15.8 19.7 0 16.2-13.9 21.5-28 21.5zm105.4-33.8c0 10-.4 19.8-8.1 27.3-6.5 6.4-16.6 8.6-25.6 8.6s-19.2-2.2-25.7-8.6c-7.7-7.5-8.1-17.3-8.1-27.3V86.3h20.1V127c0 10.1.7 21 13.6 21s13.6-10.9 13.6-21V86.3h20.1v43.5h.1zm41.2 33.8h-28.5V86.3h28.5c21.5 0 39.2 16.9 39.2 38.7 0 21.7-17.8 38.6-39.2 38.6zm120.7 0l-5.6-44.5h-.2l-18.6 44.5h-8L315 119.1h-.2l-6.5 44.5h-20l13.1-77.3h19.8l15.7 41.3 16.6-41.3h20l11.7 77.3h-20.1zm72.5-60.3h-23.9v12.9h22.7v17h-22.7v13.3h23.9v17h-44V86.2h44v17.1zm89.6 60.3h-20.1l-36.8-47.4h-.2v47.4H450V86.3h20.1l36.8 47.3h.2V86.3h20.1v77.3zM105.4 140c0 8.5-10.1 8.2-16 8.2h-2.5v-16.6h2c6.6 0 16.5-.9 16.5 8.4zm-16.3-23.3h-2.2v-15h1.4c5.4 0 11.7.4 11.7 7.5 0 6.5-5.5 7.5-10.9 7.5z"></path>
              </svg>
            </div>
          </AniLink>
        </div>
        <div className="grid grid-cols-2 text-sm gap-x-3 gap-y-8 lg:w-2/3 sm:grid-cols-4">
          <div className="space-y-3">
            <h3 className="tracking-wide uppercase dark:text-gray-50">Work</h3>
            <ul className="space-y-1 ml-0">
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/projects"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Projects
                </AniLink>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://budmen.services"
                >
                  Services
                </a>
              </li>
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/support"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Support
                </AniLink>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h3 className="uppercase dark:text-gray-50">Company</h3>
            <ul className="space-y-1 ml-0">
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/about"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  About
                </AniLink>
              </li>
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/press"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Press Coverage
                </AniLink>
              </li>
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/news"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  News
                </AniLink>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h3 className="tracking-wide uppercase dark:text-gray-50">Legal</h3>
            <ul className="space-y-1 ml-0">
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/privacy-policy"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Privacy
                </AniLink>
              </li>
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/terms-of-service"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Terms of Service
                </AniLink>
              </li>
              <li>
                <AniLink
                  rel="noopener noreferrer"
                  to="/return-policy"
                  paintDrip
                  duration={0.5}
                  hex={
                    isBrowser() && window.localStorage.theme === "dark"
                      ? "#fff"
                      : "#000"
                  }
                >
                  Return Policy
                </AniLink>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <div className="uppercase dark:text-gray-50">Around the Web</div>
            <div className="flex justify-start space-x-3">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://instagram.com/budmenindustries"
                title="Instagram"
                className="flex items-center p-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  fill="currentColor"
                  className="w-5 h-5 fill-current"
                >
                  <path d="M16 0c-4.349 0-4.891 0.021-6.593 0.093-1.709 0.084-2.865 0.349-3.885 0.745-1.052 0.412-1.948 0.959-2.833 1.849-0.891 0.885-1.443 1.781-1.849 2.833-0.396 1.020-0.661 2.176-0.745 3.885-0.077 1.703-0.093 2.244-0.093 6.593s0.021 4.891 0.093 6.593c0.084 1.704 0.349 2.865 0.745 3.885 0.412 1.052 0.959 1.948 1.849 2.833 0.885 0.891 1.781 1.443 2.833 1.849 1.020 0.391 2.181 0.661 3.885 0.745 1.703 0.077 2.244 0.093 6.593 0.093s4.891-0.021 6.593-0.093c1.704-0.084 2.865-0.355 3.885-0.745 1.052-0.412 1.948-0.959 2.833-1.849 0.891-0.885 1.443-1.776 1.849-2.833 0.391-1.020 0.661-2.181 0.745-3.885 0.077-1.703 0.093-2.244 0.093-6.593s-0.021-4.891-0.093-6.593c-0.084-1.704-0.355-2.871-0.745-3.885-0.412-1.052-0.959-1.948-1.849-2.833-0.885-0.891-1.776-1.443-2.833-1.849-1.020-0.396-2.181-0.661-3.885-0.745-1.703-0.077-2.244-0.093-6.593-0.093zM16 2.88c4.271 0 4.781 0.021 6.469 0.093 1.557 0.073 2.405 0.333 2.968 0.553 0.751 0.291 1.276 0.635 1.844 1.197 0.557 0.557 0.901 1.088 1.192 1.839 0.22 0.563 0.48 1.411 0.553 2.968 0.072 1.688 0.093 2.199 0.093 6.469s-0.021 4.781-0.099 6.469c-0.084 1.557-0.344 2.405-0.563 2.968-0.303 0.751-0.641 1.276-1.199 1.844-0.563 0.557-1.099 0.901-1.844 1.192-0.556 0.22-1.416 0.48-2.979 0.553-1.697 0.072-2.197 0.093-6.479 0.093s-4.781-0.021-6.48-0.099c-1.557-0.084-2.416-0.344-2.979-0.563-0.76-0.303-1.281-0.641-1.839-1.199-0.563-0.563-0.921-1.099-1.197-1.844-0.224-0.556-0.48-1.416-0.563-2.979-0.057-1.677-0.084-2.197-0.084-6.459 0-4.26 0.027-4.781 0.084-6.479 0.083-1.563 0.339-2.421 0.563-2.979 0.276-0.761 0.635-1.281 1.197-1.844 0.557-0.557 1.079-0.917 1.839-1.199 0.563-0.219 1.401-0.479 2.964-0.557 1.697-0.061 2.197-0.083 6.473-0.083zM16 7.787c-4.541 0-8.213 3.677-8.213 8.213 0 4.541 3.677 8.213 8.213 8.213 4.541 0 8.213-3.677 8.213-8.213 0-4.541-3.677-8.213-8.213-8.213zM16 21.333c-2.948 0-5.333-2.385-5.333-5.333s2.385-5.333 5.333-5.333c2.948 0 5.333 2.385 5.333 5.333s-2.385 5.333-5.333 5.333zM26.464 7.459c0 1.063-0.865 1.921-1.923 1.921-1.063 0-1.921-0.859-1.921-1.921 0-1.057 0.864-1.917 1.921-1.917s1.923 0.86 1.923 1.917z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://facebook.com/budmenindustries"
                title="Facebook"
                className="flex items-center p-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  className="w-5 h-5 fill-current"
                >
                  <path d="M32 16c0-8.839-7.167-16-16-16-8.839 0-16 7.161-16 16 0 7.984 5.849 14.604 13.5 15.803v-11.177h-4.063v-4.625h4.063v-3.527c0-4.009 2.385-6.223 6.041-6.223 1.751 0 3.584 0.312 3.584 0.312v3.937h-2.021c-1.984 0-2.604 1.235-2.604 2.5v3h4.437l-0.713 4.625h-3.724v11.177c7.645-1.199 13.5-7.819 13.5-15.803z"></path>
                </svg>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://twitter.com/budmenind"
                title="Twitter"
                className="flex items-center p-1"
              >
                <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 fill-current"
                >
                  <path d="M23.954 4.569a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.691 8.094 4.066 6.13 1.64 3.161a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.061a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 002.46-2.548l-.047-.02z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="py-6 flex items-center justify-between dark:text-gray-400">
        <ThemeToggler>
          {({ theme, toggleTheme }) => {
            if (theme == null) {
              return null
            }
            return (
              <label
                htmlFor="teal-toggle"
                className="inline-flex relative items-center cursor-pointer"
              >
                <input
                  type="checkbox"
                  id="teal-toggle"
                  className="sr-only peer"
                  onChange={e =>
                    toggleTheme(e.target.checked ? "dark" : "light")
                  }
                  checked={theme === "dark"}
                />
                <div className="w-11 h-6 bg-zinc-400 rounded-full peer dark:bg-gray-700 peer-focus:ring-1 peer-focus:ring-teal-300 dark:peer-focus:ring-teal-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-teal-600"></div>
                <span className="ml-3 text-xs font-medium">
                  {theme === "dark" ? <BsSun></BsSun> : <BsMoon></BsMoon>}
                </span>
              </label>
            )
          }}
        </ThemeToggler>
        <p className="text-[0.5rem] text-right my-0">
          © 2022 Isaac Budmen Industries LLC. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
